<template>
  <div class="business-goods main-bg">
    <div class="main-wrap">
      <div class="mt20">
        <business-menu></business-menu>
        <div class="fr order-r">
          <div class="celebrity-apply">
            <div class="set-nav-title">如何成为我们的名人？</div>
            <div class="apply-cont">
              <p class="apply-rule">{{applyDesc}}</p>
              <p class="apply-rule" v-html="applyDescValue"></p>
              <p class="rule-title">《名人准入标准》</p>
              <el-checkbox-group v-model="applyCheckList" class="apply-list">
                <el-checkbox v-for="(item,index) in applyList" :key="index" :label="item.content"></el-checkbox>
              </el-checkbox-group>
              <button type="button" class="btn-apply" @click="submitApply()">申请成为名人</button>
            </div>
          </div>
        </div>
      </div>

    </div>


  </div>

</template>
<script>
    import BusinessMenu from '../../components/setting/businessMenu'
    import {getByCode} from '../../api/dictionary'
    import {getCelebrityExamineInfo,getCelebrityList,submitCelebrityExamine,keepSubmitCelebrityExamine} from '../../api/shop'
  export default {
      data(){
          return {
              userInfo:JSON.parse(localStorage.getItem('user'))||null,
              status:0,//0：未提交 1：审核中 2：审核成功 3：拒绝可再次申请
              applyDescValue:'',//申请成为名人的描述内容
              applyDesc:'',//申请成为名人的描述提示
              celebrityExamineInfo:'',//自己名人申请信息
              applyCheckList:[],
              applyList:[],
          }
      },
      components:{
          BusinessMenu
      },
      created () {
          this.getByCode();
          this.getCelebrityExamineInfo();
          this.getCelebrityList();
      },
      methods:{
          getByCode(){
              getByCode({
                  code:'celebrity_desc'
              }).then(res=>{
                  this.applyDescValue=res.data.value;
                  this.applyDesc=res.data.desc;
              }).catch(()=>{})
          },
          getCelebrityExamineInfo(){
              getCelebrityExamineInfo().then(res=>{
                  this.status=res.data.status;
                  this.celebrityExamineInfo=res.data;
              }).catch(()=>{})
          },
          getCelebrityList(){
              getCelebrityList().then(res=>{
                  this.applyList=res.data;
              }).catch(()=>{})
          },
          isConditions(){
              let isApply=false;
              for(var i=0;i<this.applyCheckList.length;i++){
                  if(this.applyCheckList[i].indexOf('1')>-1){
                      isApply=true;
                      break;
                  }
              }
              let applyLen = this.applyCheckList.length;
              if(!isApply||applyLen<2){
                  this.$message({
                      message:'不满足条件请重新勾选',
                      type:'warning'
                  });
                  return false;
              }else {
                  return true;
              }
          },
          submitApply(){
              switch (this.status){
                  case 0:
                      this.$message({
                          message:'名人申请审核中...',
                          type:'warning'
                      });
                      this.saveApply();
                      break;
                  case 1:
                      break;
                  case 2:
                      this.saveOnceApply();
                      this.$message({
                          message:'名人申请已经审核成功，无需再提交',
                          type:'warning'
                      });
                      break;
                  case 3:

                      break;
                  default:
                      break;
              }
          },
          saveApply(){
              if(this.isConditions()){
                  submitCelebrityExamine({
                      shopId:this.userInfo.shopId
                  }).then(res=>{
                      console.log(res)
                  }).catch(()=>{})
              }
          },
          saveOnceApply(){
              if(this.isConditions()){
                  keepSubmitCelebrityExamine(this.celebrityExamineInfo.id).then(res=>{
                      console.log(res)
                  }).catch(()=>{})
              }

          }
      }
  }
</script>

<style lang="scss" scoped>
  @import '../../assets/css/common';
  .celebrity-apply{
    /*padding:30px 40px 50px;*/
    padding-bottom:50px;
    background-color:#ffffff;
    .apply-cont{
      padding:19px 34px 0px;
      .apply-rule{
        line-height:19.5px;}
      .rule-title{
        font-size:16px;
        color:#333;
        font-weight:600;
        padding:29px 0 20px;
      }
      .apply-list{
        .el-checkbox{
          display: block;margin-bottom:14px;}
        .el-checkbox__input.is-checked+.el-checkbox__label{color:$main-color;}
      }
      .btn-apply{
        width:170px;
        height:36px;
        background:$main-color;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        border-radius: 3px;
        font-size:14px;
        color:#fff;
        margin-top:26px;
      }
    }
  }

</style>
<style lang="scss">
  @import '../../assets/css/common';
  .apply-list{
    .el-checkbox__input:hover{color:#333333;}
    .el-checkbox__inner{border: 1px solid #999999;}
    .el-checkbox__inner:hover{border: 1px solid $main-color;}
    .el-checkbox__input.is-checked+.el-checkbox__label{color:#333333;}
    .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{color:$main-color;background-color:$main-color;}
  }
</style>
